import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getStaticVehicles } from '../services/staticData';

const VehicleList = ({ onVehicleSelect }) => {
  const navigate = useNavigate();
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchVehicles();
  }, []);

  const fetchVehicles = async () => {
    try {
      setLoading(true);
      const data = await getStaticVehicles();
      console.log('Vehicles data (static):', data); // Debug log
      // Ensure data is an array
      if (Array.isArray(data)) {
        setVehicles(data);
      } else {
        setError('Invalid data format received');
      }
    } catch (err) {
      console.error('Error fetching vehicles:', err); // Debug log
      const errorMessage = err.message || 'Failed to load vehicles';
      setError(typeof errorMessage === 'string' ? errorMessage : 'Failed to load vehicles');
    } finally {
      setLoading(false);
    }
  };

  const handleVehicleClick = (vehicle) => {
    onVehicleSelect(vehicle);
    navigate(`/timeline/${vehicle.id}`);
  };

  if (loading) {
    return <div className="loading">Loading vehicles...</div>;
  }

  if (error) {
    return <div className="error">{error}</div>;
  }

  return (
    <div className="container">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
        <h1>Vehicle Fleet</h1>
        <button 
          className="btn btn-secondary"
          onClick={() => {
            localStorage.removeItem('token');
            window.location.reload();
          }}
        >
          Logout
        </button>
      </div>
      
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '20px' }}>
        {vehicles.map((vehicle) => (
          <div 
            key={vehicle?.id || Math.random()} 
            className="card"
            style={{ cursor: 'pointer', transition: 'transform 0.2s ease' }}
            onClick={() => handleVehicleClick(vehicle)}
            onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
            onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
          >
            <h3 style={{ marginBottom: '10px', color: '#333' }}>{vehicle?.vehicle_name || 'Unknown Vehicle'}</h3>
            <p style={{ color: '#666', fontSize: '14px' }}>
              <strong>ID:</strong> {vehicle?.id || 'N/A'}
            </p>
            <p style={{ color: '#666', fontSize: '14px' }}>
              <strong>Device ID:</strong> {vehicle?.device_id || 'N/A'}
            </p>
            <div style={{ marginTop: '15px', color: '#007bff', fontSize: '14px', fontWeight: '500' }}>
              Click to view timeline →
            </div>
          </div>
        ))}
      </div>
      
      {vehicles.length === 0 && (
        <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
          No vehicles found
        </div>
      )}
    </div>
  );
};

export default VehicleList;
